import { ref, toValue } from 'vue'

import ReactionsApiHandler from '@/api/reactions'
import { handleError } from '@/utils/error-handling'

export const useReactionsManagement = commentId => {
  const reactionModalState = ref({
    isOpen: false,
    selectedReactionCode: ''
  })

  const addReaction = async reactionCode => {
    const api = new ReactionsApiHandler()

    try {
      return await api.addReaction({
        commentId: toValue(commentId),
        reactionCode
      })
    } catch (error) {
      handleError({ error })
      throw error
    }
  }

  const removeReaction = async reactionCode => {
    const api = new ReactionsApiHandler()

    try {
      return await api.removeReaction({
        commentId: toValue(commentId),
        reactionCode
      })
    } catch (error) {
      handleError({ error })
      throw error
    }
  }

  const openReactionsModal = reaction => {
    reactionModalState.value.selectedReactionCode = reaction.reactionCode
    reactionModalState.value.isOpen = true
  }

  const closeReactionsModal = () => {
    reactionModalState.value.isOpen = false
    reactionModalState.value.selectedReactionCode = ''
  }

  const selectModalReaction = reaction => {
    reactionModalState.value.selectedReactionCode = reaction.reactionCode
  }

  return {
    reactionModalState,
    addReaction,
    removeReaction,
    openReactionsModal,
    closeReactionsModal,
    selectModalReaction
  }
}
